import { render } from "./v-modal.vue?vue&type=template&id=7c44ed5e&scoped=true&ts=true"
import script from "./v-modal.vue?vue&type=script&lang=ts"
export * from "./v-modal.vue?vue&type=script&lang=ts"

import "./v-modal.vue?vue&type=style&index=0&id=7c44ed5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c44ed5e"]])

export default __exports__